<script setup lang="ts">
import axios from '@shared/axios'
import { trackEvent } from '@shared/tracking'
import { currentParams } from '@shared/url'

const trigger = useTemplateRef('trigger')
const params = currentParams()
const page = parseInt(params.get('page') || '0')
let currentPage = $ref(page)
let noMoreData = $ref(false)

async function fetchNewPage (page: number) {
  trackEvent('omni_search_expanded_infinite_scroll', trigger.value)

  const response = await axios.get(window.location.href, {
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    params: { page },
  })

  noMoreData = !response.data.includes('omni-search-result')

  if (noMoreData) return

  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = response.data

  const insertBefore = trigger.value?.parentNode as HTMLDivElement | undefined

  // Insert all the content
  tempDiv.querySelectorAll('.omni-search-expanded-section-page').forEach((el) => {
    insertBefore?.insertAdjacentElement('beforebegin', el)
    el.querySelectorAll('script').forEach((script) => {
      const scriptElement = document.createElement('script')
      scriptElement.onerror = () => {}

      Array.from(script.attributes).forEach((attr) => {
        scriptElement.setAttribute(attr.name, attr.value)
      })

      if (script.innerHTML) {
        scriptElement.innerHTML = script.innerHTML
      }
      document.head.appendChild(scriptElement)
    })
  })

  currentPage = page
}

onMounted(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          fetchNewPage(currentPage + 1)
        }
      })
    },
    {
      root: null,
      rootMargin: '0px',
      threshold: 1.0,
    },
  )

  if (trigger.value) observer.observe(trigger.value)
})
</script>

<template>
  <div ref="trigger" class="w-full h-full flex items-center justify-center pt-16">
    <LoadingIndicator v-if="!noMoreData"/>
  </div>
</template>
